import { useState } from "react";
import { X } from "lucide-react";
import "./_search-input.scss";

const SearchInput = ({
  searchIcon,
  searchType,
  value,
  onChange,
  onClick,
  searchPlaceholder,
  disabled,
  isSearchFocus,
}) => {
  const [searchValue, setSearchValue] = useState(value || "");
  const [isFocused, setIsFocused] = useState(false);

  const handleSearchFocus = () => {
    setIsFocused(true);
  };

  const handleSearchBlur = () => {
    setIsFocused(false);
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    onChange(e.target.value);
  };

  const clearSearch = () => {
    setSearchValue("");
    onChange("");
  };

  return (
    <div
      className={`form-group-search-wrapper ${
        searchType === "white" ? "input-search-white" : ""
      }`}
      onClick={() => onClick()}
    >
      <input
        type="search"
        name="search"
        id="search"
        className={searchIcon ? "with-search-icon" : ""}
        value={searchValue}
        placeholder={searchPlaceholder}
        autoComplete="off"
        disabled={disabled ? true : false}
        onFocus={isSearchFocus ? handleSearchFocus : null}
        onBlur={handleSearchBlur}
        onChange={handleSearchChange}
      />
      {(searchValue || isFocused) && (
        <X
          className="cross-icon"
          onClick={clearSearch}
          style={{ cursor: "pointer" }}
        />
      )}
      {searchIcon && (
        <img src={searchIcon} className="search-icon" alt="search icon" />
      )}
    </div>
  );
};

export default SearchInput;
